(function () {

  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .controller('RelatorioAnualSimplificadoController', RelatorioAnualSimplificadoController);

  function RelatorioAnualSimplificadoController(blockUI, FileSaver, RelatorioAnualService, PeriodoService, i18n, toaster, CONSTANTS) {

    var vm = this;

    vm.init = init;
    vm.exportar = exportar;
    vm.init();

    function init() {
      vm.periodos = PeriodoService.carregaAnosValidosAte(CONSTANTS.ANO_INICIO_ANUARIO);
      vm.periodoSelecionado = vm.periodos[0];
    }

    function exportar() {
      blockUI.start();
      RelatorioAnualService.exportarSimplificado(vm.periodoSelecionado, 'application/pdf')
      .then( (response) => {
        if (response.status === 204) {
          toaster.pop("warning",`${i18n.translate("menu.relatorio.corregedoria.anual")}
          ${i18n.translate("menu.relatorio.corregedoria.anual.simplificado")}`,
          i18n.translate("relatorio.sem.dados"));
        }
        if (response.status === 200) {
          var blob = new Blob([response.data], { type: 'application/pdf' });
          FileSaver.saveAs(blob, 'anuario-simplificado.pdf');
       }

      }).finally(() => {
        blockUI.stop();
      });
    }
  }

})();
